const mockTripData = [
  {
    tripId: "mock-trip-001",
    tripDrivingDetailsId: "mock-driving-details-001",
    vehicleKey: "MOCKVEHICLEKEY1234567890",
    startTime: "6/26/2025, 5:55:35 PM",
    endTime: "6/27/2025, 5:55:35 PM",
    startLocation: {
      type: "Point",
      coordinates: [12.899966982110776, 80.09164364682076], // [lng, lat]
    },
    endLocation: {
      type: "Point",
      coordinates: [12.765007761024153, 80.00502597433697], // [lng, lat]
    },
    avgOdometer: "120",
    distance: "30",
    averageSpeed: "40",
    topSpeed: "65",
    stopCount: "2",
    createdAt: "2024-06-01T09:01:00.000Z",
    updatedAt: "2024-06-01T09:01:00.000Z",
    places: [
      // {
      //   placeId: "mock-place-001",
      //   tripId: "mock-trip-001",
      //   time: "2024-06-01T08:15:00.000Z",
      //   location: {
      //     type: "Point",
      //     coordinates: [12.821143024805584, 80.03784148144977],
      //   },
      // },
      // {
      //   placeId: "mock-place-002",
      //   tripId: "mock-trip-001",
      //   time: "2024-06-01T08:30:00.000Z",
      //   location: {
      //     type: "Point",
      //     coordinates: [80.235, 13.075],
      //   },
      // },
      // {
      //   placeId: "mock-place-003",
      //   tripId: "mock-trip-001",
      //   time: "2024-06-01T08:45:00.000Z",
      //   location: {
      //     type: "Point",
      //     coordinates: [80.245, 13.09],
      //   },
      // },
    ],
    drivingDetail: {
      drivingDetailId: "mock-driving-details-001",
      tripId: "mock-trip-001",  
      excessSpeed: 2,
      hardBraking: 3,
      rapidAcceleration: 5,
      clutchOverrride: 2,
      idling: 2,
      gearRpm_Mismatch: 1,
      drivingScore: 50
	  },
  },
  // {
  //   tripId: "mock-trip-actual-payload-01",
  //   type: "trip_analysis",
  //   id: "3a3cf6c1-a32e-45a6-b069-e0c00703d493",
  //   serialNo: "MOCKVEHICLEKEY1234567901",
  //   data: {
  //     start: {
  //       time: "6/26/2025, 5:55:35 PM",
  //       location: {
  //         longitude: 13.082006794519753,
  //         latitude: 80.27715041506592,
  //       },
  //       coordinates: [13.082006794519753, 80.27715041506592], // [lng, lat]
  //     },
  //     end: {
  //       time: "6/27/2025, 5:55:35 PM",
  //       location: {
  //         longitude: 12.967090247180218,
  //         latitude: 80.19582698476104,
  //       },
  //       coordinates: [12.967090247180218, 80.19582698476104], // [lng, lat]
  //     },
  //     places: [],
  //   },
  // },
  // {
  //   tripId: "mock-trip-actual-payload-02",
  //   type: "trip_analysis",
  //   id: "3a3cf6c1-a32e-45a6-b069-e0c00703d493",
  //   serialNo: "MOCKVEHICLEKEY1234567901",
  //   data: {
  //     start: {
  //       time: "6/26/2025, 5:55:35 PM",
  //       location: {
  //         longitude: 13.079555,
  //         latitude: 80.200174,
  //       },
  //       coordinates: [13.079555, 80.200174], // [lng, lat]
  //     },
  //     end: {
  //       time: "6/27/2025, 5:55:35 PM",
  //       location: {
  //         longitude: 13.061506,
  //         latitude: 80.143522,
  //       },
  //       coordinates: [13.061506, 80.143522], // [lng, lat]
  //     },
  //     places: [],
  //   },
  // },
  {
    tripId: "mock-trip-002",
    tripDrivingDetailsId: "mock-driving-details-002",
    vehicleKey: "MOCKVEHICLEKEY1234567890",
    startTime: "2024-06-01T08:00:00.000Z",
    endTime: "2024-06-01T09:00:00.000Z",
    startLocation: {
      type: "Point",
      coordinates: [13.0819851014084, 80.27526252095566], // [lng, lat]
    },
    endLocation: {
      type: "Point",
      coordinates: [13.078814821105004, 80.25164078386962], // [lng, lat]
    },
    avgOdometer: "120",
    distance: "30",
    averageSpeed: "40",
    topSpeed: "65",
    stopCount: "2",
    createdAt: "2024-06-01T09:01:00.000Z",
    updatedAt: "2024-06-01T09:01:00.000Z",
    places: [
      {
        placeId: "mock-place-001",
        tripId: "mock-trip-001",
        time: "2024-06-01T08:15:00.000Z",
        location: {
          type: "Point",
          coordinates: [13.081716107750708, 80.27514780806338],
        },
      },
      {
        placeId: "mock-place-002",
        tripId: "mock-trip-001",
        time: "2024-06-01T08:15:00.000Z",
        location: {
          type: "Point",
          coordinates: [13.080996754897155, 80.27106397172538],
        },
      },
      {
        placeId: "mock-place-003",
        tripId: "mock-trip-001",
        time: "2024-06-01T08:15:00.000Z",
        location: {
          type: "Point",
          coordinates: [13.084296033649624, 80.27053854455285],
        },
      },
      {
        placeId: "mock-place-004",
        tripId: "mock-trip-001",
        time: "2024-06-01T08:15:00.000Z",
        location: {
          type: "Point",
          coordinates: [13.085596350576962, 80.26294811462475],
        },
      },
      {
        placeId: "mock-place-005",
        tripId: "mock-trip-001",
        time: "2024-06-01T08:30:00.000Z",
        location: {
          type: "Point",
          coordinates: [13.082383485200179, 80.26223790628096],
        },
      },
      {
        placeId: "mock-place-006",
        tripId: "mock-trip-001",
        time: "2024-06-01T08:45:00.000Z",
        location: {
          type: "Point",
          coordinates: [13.080293144733611, 80.26277795005558],
        },
      },
    ],
     drivingDetail: {
      drivingDetailId: "mock-driving-details-002",
      tripId: "mock-trip-002",  
      excessSpeed: 2,
      hardBraking: 3,
      rapidAcceleration: 5,
      clutchOverrride: 2,
      idling: 2,
      gearRpm_Mismatch: 1,
      drivingScore: 50
	  },
  },
  {
    tripId: "mock-trip-003",
    tripDrivingDetailsId: "mock-driving-details-001",
    vehicleKey: "MOCKVEHICLEKEY1234567890",
    startTime: "2024-06-01T08:00:00.000Z",
    endTime: "2024-06-01T09:00:00.000Z",
    startLocation: {
      type: "Point",
      coordinates: [13.071500720851617, 80.20171494960444], // [lng, lat]
    },
    endLocation: {
      type: "Point",
      coordinates: [13.065488673910579, 80.18874878089125], // [lng, lat]
    },
    avgOdometer: "120",
    distance: "30",
    averageSpeed: "40",
    topSpeed: "65",
    stopCount: "2",
    createdAt: "2024-06-01T09:01:00.000Z",
    updatedAt: "2024-06-01T09:01:00.000Z",
    places: [],
  },
  {
    tripId: "mock-trip-004",
    tripDrivingDetailsId: "mock-driving-details-001",
    vehicleKey: "MOCKVEHICLEKEY1234567890",
    startTime: "2024-06-01T08:00:00.000Z",
    endTime: "2024-06-01T09:00:00.000Z",
    startLocation: {
      type: "Point",
      coordinates: [12.971891012614554, 80.20454016516001], // [lng, lat]
    },
    endLocation: {
      type: "Point",
      coordinates: [12.967090247180218, 80.19582698476104], // [lng, lat]
    },
    avgOdometer: "120",
    distance: "30",
    averageSpeed: "40",
    topSpeed: "65",
    stopCount: "2",
    createdAt: "2024-06-01T09:01:00.000Z",
    updatedAt: "2024-06-01T09:01:00.000Z",
    places: [],
  },
  {
    tripId: "mock-trip-005",
    tripDrivingDetailsId: "mock-driving-details-001",
    vehicleKey: "MOCKVEHICLEKEY1234567890",
    startTime: "2024-06-01T08:00:00.000Z",
    endTime: "2024-06-01T09:00:00.000Z",
    startLocation: {
      type: "Point",
      coordinates: [13.082006794519753, 80.27715041506592], // [lng, lat]
    },
    endLocation: {
      type: "Point",
      coordinates: [12.967090247180218, 80.19582698476104], // [lng, lat]
    },
    avgOdometer: "120",
    distance: "30",
    averageSpeed: "40",
    topSpeed: "65",
    stopCount: "2",
    createdAt: "2024-06-01T09:01:00.000Z",
    updatedAt: "2024-06-01T09:01:00.000Z",
    places: [],
  },
];

const mockTripWithActualCoordinates = {
  tripId: "mock-trip-actual-payload-02",
  type: "trip_analysis",
  id: "3a3cf6c1-a32e-45a6-b069-e0c00703d493",
  serialNo: "THINEXT_23092024117",
  data: {
    start: {
      time: "6/26/2025, 5:55:35 PM",
      location: {
        longitude: 13.079555,
        latitude: 80.200174,
      },
      coordinates: [13.079555, 80.200174], // [lng, lat]
    },
    end: {
      time: "6/27/2025, 5:55:35 PM",
      location: {
        longitude: 13.061506,
        latitude: 80.143522,
      },
      coordinates: [13.061506, 80.143522], // [lng, lat]
    },
    places: [],
  },
};

export default mockTripData;
